import gql from "graphql-tag";

export const couponCollectionFragment = gql`
  fragment CouponCollectionFragment on CouponCollection {
    id
    title
    writeup
    classification
    collectionType
    slug
    categories
    status
    startDate
    endDate
    bannerImage {
      url
      alt
    }
    isHidden
    deeplinkUrl
    shortDynamicLink
    isFeatured
  }
`;
